import React from 'react';
import {
  Button,
  ExpoImage,
  Icon,
  ScreenContainer,
  TextInput,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const ForgotPasswordScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [emailInputValue, setEmailInputValue] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const isValidEmail = email => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const leadFunlDefaultForgetPasswordInitiatePOST =
    LeadFunlDefaultApi.useForgetPasswordInitiatePOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      hasTopSafeArea={true}
    >
      {/* Header */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
          dimensions.width
        )}
      >
        {/* Back */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        >
          <Touchable
            onPress={() => {
              try {
                navigation.goBack();
              } catch (err) {
                console.error(err);
              }
            }}
          >
            <Icon size={24} name={'AntDesign/arrowleft'} />
          </Touchable>
        </View>
        {/* Screen Heading */}
        <Text
          accessible={true}
          selectable={false}
          style={StyleSheet.applyWidth(
            {
              color: theme.colors.branding.primary,
              fontFamily: 'Poppins_400Regular',
              fontSize: 15,
            },
            dimensions.width
          )}
        >
          {'  '}
        </Text>
        {/* Blank */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        />
      </View>
      {/* Container */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
            flex: { minWidth: Breakpoints.Tablet, value: 1 },
            flexDirection: { minWidth: Breakpoints.Tablet, value: 'row' },
          },
          dimensions.width
        )}
      >
        {/* Details View */}
        <>
          {!(dimensions.width >= Breakpoints.Tablet) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
                  flex: 1,
                  justifyContent: {
                    minWidth: Breakpoints.Tablet,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              <ExpoImage
                allowDownscaling={true}
                cachePolicy={'disk'}
                contentPosition={'center'}
                transitionDuration={300}
                transitionEffect={'cross-dissolve'}
                transitionTiming={'ease-in-out'}
                {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
                resizeMode={'contain'}
                source={imageSource(Images['_659caa814a5d2ddd2cdc17d8'])}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                    {
                      height: { minWidth: Breakpoints.Tablet, value: 300 },
                      width: { minWidth: Breakpoints.Tablet, value: '70%' },
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>
          )}
        </>
        <View
          style={StyleSheet.applyWidth(
            {
              flex: { minWidth: Breakpoints.Tablet, value: 1 },
              justifyContent: 'space-evenly',
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 20,
            },
            dimensions.width
          )}
        >
          {/* Heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: theme.colors.branding.primary,
                fontFamily: 'Poppins_700Bold',
                fontSize: 35,
                marginBottom: 10,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {'Forgot\nPassword?'}
          </Text>
          {/* sub heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: palettes.App['Custom Color_9'],
                fontFamily: 'Poppins_400Regular',
                fontSize: 15,
                opacity: 0.7,
                paddingBottom: 10,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {
              'Please enter your email address and we will send your password by email.'
            }
          </Text>
          {/* Email */}
          <TextInput
            autoCapitalize={'none'}
            autoCorrect={true}
            changeTextDelay={500}
            onChangeText={newEmailValue => {
              try {
                setEmailInputValue(newEmailValue);
              } catch (err) {
                console.error(err);
              }
            }}
            webShowOutline={true}
            editable={true}
            placeholder={'Email'}
            placeholderTextColor={theme.colors.text.light}
            style={StyleSheet.applyWidth(
              {
                backgroundColor: palettes.App['Custom Color_3'],
                borderBottomWidth: 1,
                borderColor: theme.colors.border.brand,
                borderLeftWidth: 1,
                borderRadius: 24,
                borderRightWidth: 1,
                borderTopWidth: 1,
                fontFamily: 'Poppins_400Regular',
                fontSize: 15,
                height: 48,
                marginTop: 20,
                paddingBottom: 8,
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 8,
              },
              dimensions.width
            )}
            value={emailInputValue}
          />
          <View
            style={StyleSheet.applyWidth(
              {
                alignItems: 'center',
                height: 28,
                justifyContent: 'center',
                marginBottom: 6,
                marginTop: 40,
              },
              dimensions.width
            )}
          >
            <Text
              accessible={true}
              selectable={false}
              {...GlobalStyles.TextStyles(theme)['Text'].props}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.TextStyles(theme)['Text'].style,
                  theme.typography.body1,
                  { color: palettes.Brand.Error, textAlign: 'center' }
                ),
                dimensions.width
              )}
            >
              {errorMessage}
            </Text>
          </View>
          {/* Send */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              const handler = async () => {
                try {
                  const result = isValidEmail(emailInputValue);
                  if (!result) {
                    setErrorMessage('Please enter a valid email.');
                  }
                  if (!result) {
                    return;
                  }
                  setIsLoading(true);
                  const api_Response = (
                    await leadFunlDefaultForgetPasswordInitiatePOST.mutateAsync(
                      { email: emailInputValue }
                    )
                  )?.json;
                  setIsLoading(false);
                  if (!api_Response?.status) {
                    setErrorMessage(api_Response?.message);
                  }
                  if (api_Response?.status) {
                    navigation.navigate('OTPScreen', {
                      email: emailInputValue,
                    });
                  } else {
                  }
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            loading={isLoading}
            style={StyleSheet.applyWidth(
              {
                backgroundColor: theme.colors.branding.primary,
                borderRadius: 24,
                color: palettes.App['Custom Color_4'],
                fontFamily: 'Poppins_500Medium',
                fontSize: 17,
                height: 46,
                textAlign: 'center',
              },
              dimensions.width
            )}
            title={'Send'}
          />
        </View>
      </View>
    </ScreenContainer>
  );
};

export default withTheme(ForgotPasswordScreen);
